import { type CreateCatalogProductsRequestPayload } from "@vy/api-definition";
import { useMutation, useQueryClient, type UseMutationOptions } from "react-query";
import { getPrivateApi } from "../../services/api";
import { invalidateProductsQueries } from "../../utils/query-invalidation";

export function useCreateCatalogProducts(
    options?: UseMutationOptions<void, unknown, CreateCatalogProductsRequestPayload>,
) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (createCatalogProductsRequest: CreateCatalogProductsRequestPayload) => {
            const api = getPrivateApi();
            await api.createCatalogProducts({ createCatalogProductsRequest });
        },
        onSuccess: async () => {
            await invalidateProductsQueries(queryClient);
        },
        ...options,
    });
};